export default __webpack_public_path__ + "static/media/document-light.3b5b2965.svg";